// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-e8d87774] .radio_css {\n  margin-right: 70px;\n}\n[data-v-e8d87774] .radio_second {\n  margin-right: 45px;\n}\n", ""]);
// Exports
module.exports = exports;
